<template>
  <p class="meeting">
    {{ meetingStore.meetingTitle }}<br />
    {{ meetingStore.closedDate }} {{ meetingStore.meetingTime }} or as rescheduled<br />
    {{ meetingStore.meetingLocation }}
  </p>
</template>

<script setup>
import { useMeetingStore } from '@/stores/meeting'
const meetingStore = useMeetingStore()
</script>

<style scoped>
.meeting {
  font-size: 20px;
  font-weight: 700;
}
</style>
